import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-call",
  "use": "icon-call-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-call\"><path d=\"M6.83 4s-1.55.756-2.229 1.734c-.678.978-.622 1.816-.577 2.2.046.419.86 3.828 4.436 7.331 5.329 5.203 8.474 5.028 9.39 4.458.668-.408 1.822-1.595 2.15-2.293-.792-1.315-3.745-3.48-4.152-3.398-.408.081-1.618 1.326-2.421 1.222-1.437-.21-4.866-3.83-5.013-4.795-.147-.966 1.29-2.246 1.177-2.479C8.414 5.583 6.831 4 6.831 4Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol